// Externe Bibliotheken
import React, { Component } from 'react';
import CurrencyInput from 'react-currency-input-field';

// Interne Module
import tracking from '@/_helper/tracking';
import * as storage from '@/_helper/storage';
import { emitPbeCloseWebview } from '../../ch24-events.app/useAppBridge';
import { sanitizeInput } from '@/_helper/inputSanitizer';
import { buildGetRequest } from '@/_helper/apiHelper';
import { errorReport } from '@/_helper/errorReport';

// Komponenten
import ClaimDateRangePicker from '../claimDateRangePicker/ClaimDateRangePicker';
import ClaimMinuteField from './components/claimMinuteField';
import Button from '@/comp/button/button.tsx';
import OverlayModal from '@/comp/overlayModal/overlayModal.jsx';
import FormSkeleton from '@/comp/skeleton/form/FormSkeleton.js';
import AffiliateSkeleton from '@/comp/skeleton/form/AffiliateSkeleton.tsx';
import { Icon } from '@/comp/icon/icon.tsx';
import { iconMapping } from './../../index.jsx';
import { Tooltip } from '@/comp/toolTip/tooltip.tsx';

class ClaimForm extends Component {
    state = {
        accept: false,
        formSubmitting: false,
        formValid: false,
        formErrors: {
            accept: false,
        },
        entryPoints: [],
        activeSubElements: {},
        value: '',
        uploadElement: {},
        modal: false,
        loading: true,
        dataTree: undefined,
    };

    // Für C24 Kundenbereich Text
    #backLink = '';
    #backLinkText = 'zu meiner Reise';
    #bookingId = null;
    #serviceUrl = window.$serviceUrl;

    inputClassMapping = {
        multipleChoice: 'checkbox-selection',
        radio: 'radio-selection',
        dateRange: 'date-range-select',
        datePicker: 'date-select',
        minuteField: 'time-selection',
        freeText: 'textarea-selection',
        amountField: 'number-selection',
        default: '',
    };

    errorMessage = {
        datePicker: 'Bitte geben Sie ein Datum an.',
        dateRange: 'Bitte geben Sie ein Datum an.',
        date: 'Bitte geben Sie ein Datum an.',
        freeText: 'Bitte geben Sie uns eine kurze Beschreibung, damit wir die Situation besser verstehen können.',
        amountField: 'Bitte geben Sie einen Betrag in Euro an.',
        minuteField: 'Bitte geben Sie eine Stundenzahl an.',
        multipleChoice: 'Bitte wählen Sie mindestens eine Kategorie aus.',
        radio: 'Bitte wählen Sie eine Option aus.',
    };

    typeMapping = {
        multipleChoice: 'checkbox',
        datePicker: 'date',
        dateRange: 'date',
        freetext: 'text',
        amountField: 'number',
    };

    constructor(props) {
        super(props);

        tracking('loaded', 'claim');
        this.#bookingId = storage.get('bookingNumber');
        this.EntryPoint = this.EntryPoint.bind(this);
        this.DateRangeField = this.DateRangeField.bind(this);
        this.TreeSection = this.TreeSection.bind(this);
        this.Question = this.Question.bind(this);
        this.Answer = this.Answer.bind(this);
        this.Submit = this.Submit.bind(this);
        this.Modal = this.Modal.bind(this);

        if (window.$affiliate === 'ch24' && storage.get('bookingData')) {
            const bookingData = storage.get('bookingData');

            if (
                bookingData.data !== undefined &&
                bookingData.data !== null &&
                bookingData.data.pbeHash !== null &&
                bookingData.data.pbeHash !== undefined &&
                bookingData.data.pbeHash !== ''
            ) {
                let backURL = new URL(bookingData.data.pbeHash).origin + new URL(bookingData.data.pbeHash).pathname;
                this.#backLink = backURL;
            } else {
                this.#backLink = 'https://kundenbereich.check24.de/';
            }
        }
    }

    componentDidMount() {
        this.requestTree();

        if (this.props.initialState) {
            this.setState(() => this.props.initialState);
        }

        this.setState((state) => {
            state.formErrors['submit'] = false;
            return state;
        });

        if (this.state.dataTree) {
            this.setState((state) => {
                state.loading = false;
                return state;
            });
        }
    }

    EntryPoint(args) {
        const entryPoint = args.entryPoint;
        return (
            <div key={entryPoint.key} className="checkbox-selection">
                <input
                    id={entryPoint.key}
                    type="checkbox"
                    name="entryPoint"
                    value={entryPoint.key}
                    checked={-1 !== this.state.entryPoints.indexOf(entryPoint.key)}
                    onChange={(event) => {
                        event.persist();
                        this.setState((state) => {
                            if (event.target.checked) {
                                state.entryPoints.push(entryPoint.key);
                            } else {
                                state.entryPoints.splice(state.entryPoints.indexOf(entryPoint.key), 1);
                                Object.keys(state.activeSubElements).forEach((key) => {
                                    if (key.startsWith(entryPoint.key)) {
                                        state.activeSubElements[key].forEach((entry) => {
                                            let answers = entry.element?.answers;
                                            if (answers) {
                                                Object.keys(answers).forEach((key) => {
                                                    answers[key].value = undefined;
                                                    answers[key].checked = false;
                                                });
                                            }
                                        });
                                        delete state.activeSubElements[key];
                                    }
                                });
                                this.removeUploadElement(state, entryPoint.key, 'all');
                                delete state.activeSubElements[entryPoint.key];
                            }
                            return state;
                        });
                    }}
                />
                <label htmlFor={entryPoint.key}>
                    <span className={'icon-' + entryPoint.key}>
                        <Icon name={iconMapping[entryPoint.key]} size={30} ariaHidden />
                        {entryPoint.name}
                    </span>
                    {window.$browserInfo.device !== 'mobile' && (
                        <Icon className="icon-close" size={30} name="close" ariaHidden />
                    )}
                </label>
            </div>
        );
    }

    Question(args) {
        const question = args.question;
        const answers = [];
        if (question.type === 'dateRange' || question.type === 'datePicker') {
            answers.push(<this.DateRangeField key={question.key} treeKey={args.treeKey} question={question} />);
        } else {
            Object.keys(question.answers).forEach((answer) => {
                answers.push(
                    <this.Answer
                        key={question.answers[answer].key}
                        answer={question.answers[answer]}
                        treeKey={args.treeKey}
                        question={question}
                    />
                );
            });
        }

        return (
            <div className="question-container">
                <div className="heading">
                    <h3>{question.name}</h3>
                    {question.additionalInfo && (
                        <Tooltip classList="info-layer" iconSize={24} placement="right">
                            {question.additionalInfo}
                        </Tooltip>
                    )}
                </div>
                <div
                    className={
                        (question.type === 'multipleChoice' ? 'multiple-choice-row ' : '') +
                        (question.type === 'dateRange' || question.type === 'datePicker' ? 'date-row ' : '') +
                        'row'
                    }>
                    {answers}
                </div>
                {this.state.formErrors[args.treeKey + '_' + args.question.key] &&
                    (args.question.type ? (
                        <div className="error">{this.errorMessage[args.question.type]}</div>
                    ) : (
                        <div className="error">Bitte füllen Sie das Feld aus.</div>
                    ))}
            </div>
        );
    }

    formatHoursToMinute(value) {
        let minutes = 0;
        let tempValue = value;
        tempValue = tempValue.toLowerCase().replace('s', '');
        tempValue = tempValue.toLowerCase().replace('t', '');
        tempValue = tempValue.toLowerCase().replace('d', '');
        tempValue = tempValue.toLowerCase().replace('.', '');
        tempValue = tempValue.replace(/\s/g, '');
        if (tempValue === '') {
            return NaN;
        }
        for (var i = 0; i < tempValue.length; i++) {
            if (i === 0) {
                minutes = minutes + parseInt(tempValue.charAt(0)) * 10 * 60;
            }
            if (i === 1) {
                minutes = minutes + parseInt(tempValue.charAt(1)) * 60;
            }
            if (i === 2) {
                minutes = minutes + parseInt(tempValue.charAt(2)) * 10;
            }
            if (i === 3) {
                minutes = minutes + parseInt(tempValue.charAt(3));
            }
        }
        return minutes;
    }

    /**
     * Checked whether a date is valid or not
     * @param date
     * @returns {boolean}
     */
    dateIsValid(date) {
        let parts = date.split('.');
        let day = parseInt(parts[0]);
        let month = parseInt(parts[1]);
        let year = parseInt(parts[2]);
        if (
            isNaN(day) ||
            day < 1 ||
            day > 31 ||
            isNaN(month) ||
            month < 1 ||
            month > 12 ||
            isNaN(year) ||
            year < 2015
        ) {
            return false;
        }
        let newDate = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
        let today = new Date();
        return (
            newDate instanceof Date &&
            !isNaN(newDate) &&
            Date.parse(newDate.toDateString()) <= Date.parse(today.toDateString())
        );
    }

    handleAnswerInputChange(event, args) {
        let answer = args.answer;
        const type = this.typeMapping[args.question.type] || args.question.type;
        const inputName =
            type === 'date' || type === 'freeText' || type === 'minuteField' || type === 'number'
                ? args.treeKey + '_' + args.question.key + '_' + answer.key
                : args.treeKey + '_' + args.question.key;
        event.persist();
        this.setState((state) => {
            state.formErrors[inputName] = false;
            state.formErrors['submit'] = false;
            state.formValid = false;
            let element;
            if ('checkbox' === type) {
                try {
                    element = {
                        isTree: true,
                        element: {
                            name: answer.name,
                            question: JSON.parse(JSON.stringify(answer.question)),
                            key: answer.key,
                        },
                        key: answer.key,
                    };
                } catch {
                    this.props.changeStep(4);
                }
            } else {
                if (!answer.isEnd) {
                    try {
                        element = { element: JSON.parse(JSON.stringify(answer.question)) };
                    } catch {
                        this.props.changeStep(4);
                    }
                } else {
                    element = { isEnd: true, element: { type: args.question.type }, isTree: true };
                }
            }

            if (type === 'minuteField') {
                answer.formatedValue = event.target.value;
                let value = this.formatHoursToMinute(event.target.value);
                if (!isNaN(value)) {
                    answer.value = sanitizeInput(value);
                } else {
                    state.formErrors[inputName] = true;
                }
            } else {
                answer.value = sanitizeInput(event.target.value);
            }

            if (type === 'date' && answer.value.length === 10) {
                if (!this.dateIsValid(answer.value)) {
                    state.formErrors[inputName] = true;
                }
            }

            answer.checked = !!event.target.checked;
            element.element.inputName = inputName;
            element.originAnswerKey = answer.key;

            let oldIndex;
            state.activeSubElements[args.treeKey].some((element, index) => {
                if (element.element.inputName === inputName) {
                    oldIndex = index;
                    return true;
                }

                return false;
            });

            if (type === 'checkbox' && !event.target.checked) {
                answer.value = undefined;
                answer.checked = false;
                this.removeEntriesRecursive(state, element, args.treeKey);
                Object.keys(state.activeSubElements).forEach((key) => {
                    if (key.startsWith(`${args.treeKey}_${answer.name}`)) {
                        delete state.activeSubElements[key];
                    }
                });
            } else if (type === 'radio' && oldIndex !== undefined) {
                let oldQuestion = state.activeSubElements[args.treeKey][oldIndex - 1];
                this.removeRecursiveForRadio(
                    state,
                    state.activeSubElements[args.treeKey][oldIndex],
                    args.treeKey,
                    oldQuestion
                );

                state.activeSubElements[args.treeKey][oldIndex] = element;
                if (answer.uploadIndicator) {
                    this.addUploadElement(state, args.treeKey, answer.answerId, answer.uploadIndicator);
                }
            } else if (type === 'date') {
                if (answer.value.length === 10) {
                    if (this.dateIsValid(answer.value) && !oldIndex) {
                        state.activeSubElements[args.treeKey].push(element);
                        if (answer.uploadIndicator) {
                            this.addUploadElement(state, args.treeKey, answer.answerId, answer.uploadIndicator);
                        }
                    }
                }
            } else {
                if ('checkbox' === type || !oldIndex) {
                    state.activeSubElements[args.treeKey].push(element);
                    if (answer.uploadIndicator) {
                        this.addUploadElement(state, args.treeKey, answer.answerId, answer.uploadIndicator);
                    }
                }
            }
            return state;
        });
    }

    removeRecursiveForRadio(state, element, treeKey, oldQuestion) {
        const answers = element.element.answers;
        if (!answers) {
            return;
        }
        if (
            oldQuestion !== undefined &&
            oldQuestion.element !== undefined &&
            oldQuestion.element.answers !== undefined
        ) {
            let oldAnswerIsUploadIndicator = false;
            let uploadType;
            Object.keys(oldQuestion.element.answers).forEach((item) => {
                let oldAnswer = oldQuestion.element.answers[item];
                if (oldAnswer.uploadIndicator !== null && oldAnswer.checked === false) {
                    oldAnswerIsUploadIndicator = true;
                    uploadType = oldAnswer.uploadIndicator;
                }
            });
            if (oldAnswerIsUploadIndicator === true) {
                this.removeUploadElement(state, treeKey, uploadType);
            }
        }
        Object.keys(answers).forEach((key) => {
            if (answers[key].uploadIndicator !== null) {
                this.removeUploadElement(state, treeKey, answers[key].uploadIndicator);
            }
            state.activeSubElements[treeKey].forEach((entry, index) => {
                if (entry.originAnswerKey === answers[key].key) {
                    if (!entry.isTree) {
                        this.removeRecursiveForRadio(state, entry, treeKey);
                    } else if (!entry.isEnd) {
                        Object.keys(state.activeSubElements).forEach((key) => {
                            if (key.startsWith(`${treeKey}_${entry.element.name}`)) {
                                delete state.activeSubElements[key];
                            }
                        });
                    }
                    state.activeSubElements[treeKey].splice(index, 1);
                }
            });
        });
    }

    removeUploadElement(state, treeKey, uploadType) {
        if (uploadType === 'all') {
            Object.keys(state.uploadElement).forEach((key) => {
                if (key.startsWith(`${treeKey}`)) {
                    let fileUploadName = key + '_' + state.uploadElement[key];
                    if (fileUploadName !== undefined) {
                        this.props.removeFromFileList(key);
                    }
                    delete state.uploadElement[key];
                }
            });
        } else {
            if (state.uploadElement[treeKey] !== undefined) {
                let index = state.uploadElement[treeKey].indexOf(uploadType);
                if (index >= 0) {
                    state.uploadElement[treeKey].splice(index, 1);
                    if (state.uploadElement[treeKey].length === 0) {
                        this.props.removeFromFileList(treeKey + '_' + uploadType);
                        delete state.uploadElement[treeKey];
                    }
                }
            }
        }
    }

    addUploadElement(state, treeKey, answerId, uploadType) {
        let isUploadElement = false;
        if (state.uploadElement[treeKey] === undefined) {
            state.uploadElement[treeKey] = [];
        } else {
            state.uploadElement[treeKey].forEach((item) => {
                if (item === uploadType) {
                    isUploadElement = true;
                }
            });
        }
        if (!isUploadElement) {
            this.props.removeFromFileList(treeKey);
            state.uploadElement[treeKey].push(uploadType);
        }
    }

    DateRangeField(args) {
        return (
            <ClaimDateRangePicker
                args={args}
                formErrors={this.state.formErrors}
                handleAnswerInputChange={(event, changeArgs) => this.handleAnswerInputChange(event, changeArgs)}
            />
        );
    }

    Answer(args) {
        const answer = args.answer;
        const type = this.typeMapping[args.question.type] || args.question.type;
        const inputName =
            type === 'freeText' || type === 'minuteField' || type === 'number'
                ? args.treeKey + '_' + args.question.key + '_' + answer.key
                : args.treeKey + '_' + args.question.key;

        let returnAnswer;

        if (type === 'minuteField') {
            returnAnswer = (
                <ClaimMinuteField
                    args={args}
                    className={this.state.formErrors[inputName] ? 'error' : ''}
                    handleAnswerInputChange={(event, changeArgs) => this.handleAnswerInputChange(event, changeArgs)}
                />
            );
        } else if (type === 'number') {
            returnAnswer = (
                <CurrencyInput
                    name={inputName}
                    placeholder="0,00 €"
                    decimalsLimit={2}
                    intlConfig={{ locale: 'de-DE', currency: 'EUR' }}
                    value={answer.value !== undefined ? answer.value.replace('.', ',') : answer.value}
                    maxLength={7}
                    onValueChange={(value) => {
                        this.handleAnswerInputChange({ target: { value: value }, persist: () => true }, args);
                    }}
                />
            );
        } else if (type === 'freeText') {
            returnAnswer = (
                <textarea
                    rows="4"
                    id={args.treeKey + answer.key}
                    name={inputName}
                    className={this.state.formErrors[inputName] ? 'error' : ''}
                    onChange={(event) => {
                        this.handleAnswerInputChange(event, args);
                    }}
                    value={answer.value ? answer.value : undefined}></textarea>
            );
        } else {
            returnAnswer = (
                <>
                    <input
                        id={args.treeKey + answer.key}
                        type={type}
                        name={inputName}
                        className={type !== 'checkbox' && this.state.formErrors[inputName] ? 'error' : ''}
                        value={
                            answer.value
                                ? answer.value
                                : type === 'checkbox' || type === 'radio'
                                  ? answer.key
                                  : undefined
                        }
                        checked={!!answer.checked}
                        onChange={(event) => {
                            if (type === 'radio') {
                                const radioAnswers = args.question.answers;
                                Object.keys(radioAnswers).forEach((key) => {
                                    radioAnswers[key].checked = radioAnswers[key].key === answer.key;
                                });
                            }
                            this.handleAnswerInputChange(event, args);
                        }}
                    />
                    {type === 'number' && <i>€</i>}
                    {type !== 'date' && (
                        <label className="icon" htmlFor={args.treeKey + answer.key}>
                            <span>{answer.name}</span>
                        </label>
                    )}
                </>
            );
        }

        return (
            <>
                <div
                    key={answer.key}
                    className={
                        (this.inputClassMapping[args.question.type] || this.inputClassMapping.default) + ' answer'
                    }>
                    {returnAnswer}
                    {type !== 'checkbox' &&
                        type !== 'radio' &&
                        this.state.formErrors[inputName] &&
                        (args.question.type ? (
                            <div className="error">{this.errorMessage[args.question.type]}</div>
                        ) : (
                            <div className="error">Bitte füllen Sie das Feld aus.</div>
                        ))}
                </div>
            </>
        );
    }

    removeEntriesRecursive(state, element, treeKey) {
        state.activeSubElements[treeKey].forEach((entry, index) => {
            if (entry.element.key === element.element.key && element.originAnswerKey === entry.originAnswerKey) {
                state.activeSubElements[treeKey].splice(index, 1);
                if (element.isTree) {
                    let parsedElementName = this.props.escapeString(element.element.name);
                    Object.keys(state.activeSubElements).forEach((key) => {
                        if (key.startsWith(`${treeKey}_${parsedElementName}`)) {
                            this.removeUploadElement(state, treeKey + '_' + parsedElementName, 'all');
                            delete state.activeSubElements[key];
                        }
                    });
                }
                let answers = entry.element.question?.answers;
                let newElement;
                if (!answers) {
                    return;
                }
                Object.keys(answers).forEach((key) => {
                    let answer = answers[key];
                    answer.value = undefined;
                    answer.checked = false;
                    if (answer.type === 'checkbox') {
                        newElement = {
                            isTree: true,
                            element: { name: answer.name, question: { ...answer.question }, key: answer.key },
                            key: answer.key,
                        };
                    }
                    newElement = { element: { ...answer.question }, originAnswerKey: answer.key };
                    this.removeEntriesRecursive(state, newElement, treeKey);
                });
            }
        });
    }

    TreeSection(args) {
        let $this = this;
        const tree = args.tree;
        const treeKey = this.props.escapeString(args.treeKey);
        let activeSubElements = $this.state.activeSubElements;
        if (undefined === activeSubElements[treeKey]) {
            activeSubElements[treeKey] = [];
            activeSubElements[treeKey].push({ element: tree.question });
        }
        const elements = [];
        activeSubElements[treeKey].forEach((activeElement) => {
            if (!activeElement.isTree) {
                elements.push(
                    <this.Question key={activeElement.element.key} question={activeElement.element} treeKey={treeKey} />
                );
            } else {
                if (!activeElement.isEnd) {
                    const newTreeKey = `${treeKey}_${activeElement.element.name}`;
                    elements.push(
                        <this.TreeSection key={newTreeKey} tree={activeElement.element} treeKey={newTreeKey} />
                    );
                    $this.state.formValid = false;
                } else {
                    if (activeElement.element.type !== 'dateRange') {
                        $this.state.formValid = true;
                    }
                }
            }
        });

        return (
            <div className={'article'}>
                <div className={'container'}>
                    {treeKey.indexOf('_') === -1 ? (
                        <button
                            className={'accordion categoryText active icon-' + tree.key}
                            onClick={(event) => ClaimForm.triggerAccordion(event)}>
                            <Icon className="icon-category" name={iconMapping[tree.key]} size={40} ariaHidden />
                            {tree.name}
                            <Icon name="arrowForwardIos" size={18} className="icon-direction" ariaHidden />
                        </button>
                    ) : treeKey.split('_').length - 1 > 1 ? (
                        <p className="categoryText subtext">{tree.name}</p>
                    ) : (
                        <p className="categoryText">{tree.name}</p>
                    )}
                    <div className="subbox panel">{elements}</div>
                </div>
            </div>
        );
    }

    Submit() {
        return (
            <>
                <Button
                    valid={this.state.formValid}
                    validated={this.state.formVacancy}
                    type="submit"
                    label="Weiter zu den Nachweisen"
                />
            </>
        );
    }

    closeModal = () => {
        this.setState((state) => {
            state.modal = false;
            return state;
        });
    };

    Modal() {
        return (
            <OverlayModal name="claim-form" scrollable={false} showLogo={true} toggleModal={this.closeModal}>
                <div>
                    <p className="modal-title">Möchten Sie wirklich zurück?</p>
                    <p className="modal-text">
                        Sind Sie sicher, dass Sie zurück zu Ihrer Reise wollen?
                        <br />
                        Ihr bisheriger Fortschritt wird nicht gespeichert.
                    </p>
                </div>
                <div className="modal-button-container">
                    <Button handleClick={this.closeModal} label="Nein, ich bleibe hier" />
                    <a className="button-element button-white" rel="noopener noreferrer" href={this.#backLink}>
                        {`Ja, zurück ${this.#backLinkText}`}
                    </a>
                </div>
            </OverlayModal>
        );
    }

    static triggerAccordion(event) {
        event.preventDefault();

        event.currentTarget.nextElementSibling.style.display = event.currentTarget.classList.toggle('active')
            ? 'block'
            : 'none';
    }

    handleSubmit(event) {
        event.preventDefault();
        let result = {};
        let valid = true;
        let formErrors = [];
        this.setState((state) => {
            state.formErrors = formErrors;
            return state;
        });

        let form = document.forms[0];
        let formList = {};
        Object.keys(form.elements).forEach((index) => {
            let element = form.elements[index];
            let formType = element.type;
            if (
                (formType === 'checkbox' || formType === 'radio' || formType === 'text' || formType === 'textarea') &&
                element.name !== ''
            ) {
                let isElemInList = false;
                Object.keys(formList).forEach((item) => {
                    if (item === element.name) {
                        isElemInList = true;
                    }
                });
                if (isElemInList === false) {
                    formList[element.name] = formType;
                }
            }
        });

        Object.keys(formList).forEach((item) => {
            let lastRef = result;
            let elem, value;
            if (formList[item] === 'checkbox' || formList[item] === 'radio') {
                elem = document.querySelector(`input[name=${item}]:checked`);
            } else if (formList[item] === 'textarea') {
                elem = document.querySelector(`textarea[name=${item}]`);
            } else {
                elem = document.querySelector(`input[name=${item}]`);
            }

            if (elem) {
                value = elem.value;
                let parent = elem.parentNode;
                if (parent !== undefined && parent.classList.contains('time-selection-input') && value !== '') {
                    if (!isNaN(this.formatHoursToMinute(value))) {
                        value = this.formatHoursToMinute(value);
                    } else {
                        formErrors.push(item);
                        valid = false;
                    }
                } else if (parent !== undefined && parent.classList.contains('date-selection') && value !== '') {
                    if (!this.dateIsValid(value)) {
                        formErrors.push(item);
                        valid = false;
                    }
                }
            }
            if (!elem || '' === value) {
                formErrors.push(item);
                valid = false;
                return;
            }

            const parts = item.split('_');
            if (parts.length < 3) {
                return;
            }
            parts.forEach((part, index) => {
                if (!isNaN(part)) {
                    return;
                }
                if ('question' === part) {
                    if (!lastRef.questions) {
                        lastRef.questions = {};
                    }
                    if (!lastRef.questions['question_' + parts[index + 1]]) {
                        lastRef.questions['question_' + parts[index + 1]] = { answers: {} };
                    }
                    lastRef = lastRef.questions['question_' + parts[index + 1]];
                    if (!parts[index + 2]) {
                        lastRef.answers[value] = value;
                    }
                    return;
                }
                if ('answer' === part) {
                    lastRef.answers[`answer_${parts[index + 1]}`] = value;
                    return;
                }
                if (!lastRef[part]) {
                    lastRef[part] = {};
                }
                lastRef = lastRef[part];
            });
        });

        if (!valid) {
            this.setState((state) => {
                formErrors.forEach((input) => {
                    state.formErrors[input] = true;
                });
                state.formErrors['submit'] = true;
                state.formValid = false;
                return state;
            });
            return;
        }

        if (this.state.formValid) {
            this.props.setDataReturnTree(result);
            this.props.setDataTree(this.state.dataTree);
            this.props.setUploadElements(this.state.uploadElement);
            this.props.saveState(this.state);
            this.props.changeStep(1);
        } else {
            this.setState((state) => {
                state.formErrors['submit'] = true;
                return state;
            });
        }
    }

    requestTree() {
        const requestConfig = buildGetRequest(this.#serviceUrl, '/getComplaintTree', {
            isHotelOnly: Number(storage.get('bookingData')?.data?.travelType === 'hotel'),
            bookingNumber: storage.get('bookingNumber'),
        });

        fetch(requestConfig.url, {
            method: requestConfig.method,
            headers: requestConfig.headers,
        })
            .then((response) => (response.ok ? response.json() : Promise.reject()))
            .then((data) => {
                if (!data.EntryPoint) {
                    return Promise.reject();
                }
                this.setState({ loading: false });
                this.setState(() => {
                    return { dataTree: data };
                });
            })
            .catch((error) => {
                errorReport({ source: 'ClaimForm', error: error });
                window.location.href = '#/';
            });
    }

    render() {
        const entryPoints = [];
        const mainTreeSections = [];

        if (this.state.loading || !this.state.dataTree) {
            if (window.$affiliate === false) {
                return <FormSkeleton />;
            } else if (window.$affiliate === 'ch24') {
                return <AffiliateSkeleton />;
            }
        }
        Object.keys(this.state.dataTree.EntryPoint).forEach((entryPoint) => {
            entryPoints.push(
                <this.EntryPoint
                    handleCheckboxChange={this.handleCheckboxChange}
                    key={this.state.dataTree.EntryPoint[entryPoint].key}
                    entryPoint={this.state.dataTree.EntryPoint[entryPoint]}
                />
            );
        });
        this.state.entryPoints.forEach((entryPoint) => {
            mainTreeSections.push(
                <this.TreeSection
                    key={this.state.dataTree.EntryPoint[entryPoint].key + 'section'}
                    tree={this.state.dataTree.EntryPoint[entryPoint]}
                    treeKey={this.state.dataTree.EntryPoint[entryPoint].key}
                />
            );
        });

        return (
            <section className="claim-form-section">
                <section className="content-wrapper intro-section">
                    <div className="intro row">
                        <div className="intro-title">
                            <h1>Ihr Reklamationsformular</h1>
                        </div>
                        <div className="intro-text">
                            <p>
                                Sie haben etwas zu beanstanden? Kein Problem – wir kümmern uns darum! Füllen Sie einfach
                                das Formular aus und laden Sie im zweiten Schritt Ihre Nachweise (z. B. Fotos,
                                Rechnungen) hoch.
                            </p>
                        </div>
                    </div>
                </section>

                {/* FORM */}
                <form
                    className={`claim-form txtL ${this.state.formSubmitting ? 'validate' : ''}`}
                    method="post"
                    autoComplete="off"
                    noValidate=""
                    onChange={() => {
                        tracking('interaction', 'claim');
                    }}
                    onSubmit={(event) => this.handleSubmit(event)}>
                    <section className="section-choose-category">
                        <article className="article">
                            <div className="container">
                                <div className="question-container">
                                    <h3>
                                        Bei welchem Teil der Reise ist etwas nicht nach Ihrer Vorstellung gelaufen?
                                        (Mehrfachauswahl möglich)
                                    </h3>
                                    <div className="row multiple-choice-row">{entryPoints}</div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section className="section-main-tree">{mainTreeSections}</section>

                    <section className="section-submit">
                        <div className="container">
                            <div className="row button-container">
                                {storage.get('mode') !== null && storage.get('mode') === 'app' ? (
                                    <span
                                        className="ci-link"
                                        onClick={() => {
                                            emitPbeCloseWebview();
                                        }}>
                                        &lsaquo;&lsaquo; {`Zurück ${this.#backLinkText}`}
                                    </span>
                                ) : (
                                    <a
                                        href={this.#backLink}
                                        className="back-button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({ modal: true });
                                        }}>
                                        <Icon name="keyboardArrowLeft" ariaHidden />
                                        {`Zurück ${this.#backLinkText}`}
                                    </a>
                                )}
                                <this.Submit
                                    key="submit"
                                    formValid={this.state.formValid}
                                    formVacancy={this.state.formVacancy}
                                />
                            </div>
                            {this.state.formErrors['submit'] && (
                                <p className="error">
                                    Es scheint so, als hätten Sie das Formular noch nicht komplett ausgefüllt. Bitte
                                    beantworten Sie die restlichen Fragen und versuchen es erneut.
                                </p>
                            )}
                        </div>
                    </section>
                    {this.state.modal && <this.Modal />}
                </form>
            </section>
        );
    }
}

export default ClaimForm;
